export default function parseBooleanValue (value) {
    if (value === 'true') {
        return true
    } else if (value === 'false') {
        return false
    }

    return Boolean(value)
}


// WEBPACK FOOTER //
// ./src/helpers/parse-boolean-value.js